import { useQuery } from "@apollo/client";

import { GET_USER_CLIPS } from "MVVM/GraphQL/getUserClips";
import { useFiltersFromUrl } from "MVVM/Hooks/useFiltersFromUrl";

export const ProfileClipsViewModel = ({ game, user }: any) => {
  const { filters: selectedFilters } = useFiltersFromUrl();

  const formattedFilters = Object.entries(selectedFilters).map(
    ([key, values]) => ({
      key,
      values: Array.isArray(values) ? values.map(String) : [String(values)],
    }),
  );

  const { data, error, loading, fetchMore, refetch, networkStatus } = useQuery(
    GET_USER_CLIPS,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      skip: !user,
      variables: {
        first: 10,
        userId: user,
        filters: {
          game,
          filters: formattedFilters.length > 0 ? formattedFilters : undefined,
        },
      },
    },
  );

  const handleFetchMore = async () => {
    await fetchMore({
      variables: {
        after: data?.getUser?.clips?.pageInfo?.endCursor,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          getUser: {
            ...fetchMoreResult.getUser,
            clips: {
              ...fetchMoreResult.getUser.clips,
              nodes: [
                ...(prev.getUser?.clips?.nodes || []),
                ...(fetchMoreResult.getUser?.clips?.nodes || []),
              ],
            },
          },
        };
      },
    });
  };

  const handleFetchWithFilters = async (filters: any) => {
    const formattedFilters = Object.entries(filters).map(([key, values]) => ({
      key,
      values: Array.isArray(values) ? values.map(String) : [String(values)],
    }));

    await refetch({
      first: 10,
      userId: user,
      filters: {
        game,
        filters: formattedFilters,
      },
    });
  };

  return {
    refetch: handleFetchMore,
    data: data?.getUser,
    pageInfo: data?.getUser?.clips?.pageInfo,
    loading,
    error,
    handleFetchWithFilters,
    networkStatus,
  };
};
